/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adminThreadsControllerFindAll } from "./adminThreadsControllerFindAll";
import { adminThreadsControllerFindOne } from "./adminThreadsControllerFindOne";

export function adminThreadsService() {
  return { adminThreadsControllerFindAll, adminThreadsControllerFindOne }
}